import { render, staticRenderFns } from "./Reception.vue?vue&type=template&id=c5fb25ce&scoped=true"
import script from "./Reception.vue?vue&type=script&lang=js"
export * from "./Reception.vue?vue&type=script&lang=js"
import style0 from "./Reception.vue?vue&type=style&index=0&id=c5fb25ce&prod&lang=scss&scoped=true"
import style1 from "./Reception.vue?vue&type=style&index=1&id=c5fb25ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fb25ce",
  null
  
)

export default component.exports